/* @flow */

export const SuggestedReplyStatus = {
    SUCCESS: 'SUCCESS',
    LIMIT_REACHED: 'LIMIT_REACHED',
    NOT_SUPPORTED: 'NOT_SUPPORTED',
    ALREADY_ACCEPTED: 'ALREADY_ACCEPTED',
    FEATURE_FLAGGED: 'FEATURE_FLAGGED',
    DISABLED: 'DISABLED',
    ERROR: 'ERROR',
};
